import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import { convertUTCToTimezone, getDateFormat2, getTimeFormat1 } from 'srcReact/helpers/datetimeHelper'

function SelectNewsFeed({ closeModal, mixrFeeds, groupFeeds, handleGroupNewsFeedChange, handleMixrNewsFeedChange }) {
  const { t } = useTranslation()

  return (
    <div className={styles.selectNewsFeedWrapper}>
      <button type='button' className={styles.closeButton} onClick={closeModal}>
        <Icon name='close24' />
      </button>
      <h1 className={styles.heading}>{t('feed.selectPostTitle')}</h1>
      <div className={styles.container}>
        <div className={styles.boxed}>
          {groupFeeds &&
            groupFeeds.length >= 1 &&
            groupFeeds.map((g, i) => (
              <React.Fragment key={i}>
                {i === 0 && <h2 className={styles.heading}>{t('feed.groups')}</h2>}
                <button className={styles.newsFeed} onClick={() => handleGroupNewsFeedChange(g)}>
                  {g.group_picture ? (
                    <img src={g.group_picture} alt={g.group_title} className={styles.picture} />
                  ) : (
                    <img
                      src={require('../../../../../assets/images/background-default-mixr.jpg')}
                      alt='default'
                      className={styles.picture}
                    />
                  )}
                  <span className={styles.title}>{g.group_title}</span>
                </button>
              </React.Fragment>
            ))}
          {mixrFeeds &&
            mixrFeeds.length >= 1 &&
            mixrFeeds.map((m, i) => (
              <React.Fragment key={i}>
                {i === 0 && <h2 className={styles.heading}>{t('feed.mixrs')}</h2>}
                <button className={styles.newsFeed} onClick={() => handleMixrNewsFeedChange(m)}>
                  {m.mixr_picture ? (
                    <img src={m.mixr_picture} alt={m.mixr_title} className={styles.picture} />
                  ) : (
                    <img
                      src={require('../../../../../assets/images/background-default-mixr.jpg')}
                      alt='default'
                      className={styles.picture}
                    />
                  )}
                  <div className={styles.content}>
                    <span className={styles.date}>
                      {convertUTCToTimezone(m.event_utc_start_datetime, m.event_utc_offset, getDateFormat2())}
                    </span>
                    <span className={styles.time}>
                      {t('global.at')}{' '}
                      {convertUTCToTimezone(m.event_utc_start_datetime, m.event_utc_offset, getTimeFormat1())}
                    </span>
                    <span className={styles.title}>{m.mixr_title}</span>
                  </div>
                  <div className={`${styles.overlay} ${m.is_over === 1 && styles.isOver}`}>
                    {m.recurrence_type === 'none' ? (
                      <Icon name='calendar24' size='large24' styleModifier={styles.customIcon} />
                    ) : (
                      <Icon name='recurring-mixrs' size='large24' styleModifier={styles.customIcon} />
                    )}
                  </div>
                </button>
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  )
}

export default SelectNewsFeed
